import { Icon } from '@chakra-ui/react';

export const LocationIcon = (props: any) => (
  <Icon aria-label="location icon" viewBox="1 1 16 16" {...props}>
    <path
      fill="currentColor"
      d="m9 1.5c3.3137085 0 6 2.6862915 6 6 0 2.19799479-1.6881181 4.730172-4.968184 7.8387405l-1.031816.9778677-1.03181596-.9778677c-3.2800659-3.1085685-4.96818404-5.64074571-4.96818404-7.8387405 0-3.3137085 2.6862915-6 6-6zm0 1.5c-2.48528137 0-4.5 2.01471863-4.5 4.5 0 1.65685425 1.5 3.9068542 4.5 6.75 3-2.8431458 4.5-5.09314575 4.5-6.75 0-2.48528137-2.0147186-4.5-4.5-4.5zm0 2.25c1.2426407 0 2.25 1.00735931 2.25 2.25s-1.0073593 2.25-2.25 2.25c-1.24264069 0-2.25-1.00735931-2.25-2.25s1.00735931-2.25 2.25-2.25z"
    />
  </Icon>
);
